import { useContext } from "react";
import ConfigContext from "../context/config/ConfigContext";

const useConfigs = () => {
  return useContext(ConfigContext);
};

export default useConfigs;
